/**
 * date：2023-09-24
 * author：Roasilan
 * purpose：更改range参数
 */
import { shareScope } from '@/api/modules/public.js'
import { getIsSys } from './permission'

const mixin = {
  data () {
    return {
      rangeArray: []
    }
  },
  computed: {
    i18n () {
      return this.$i18n.locale
    },
    isSysAdmin () {
      return getIsSys()
    }
  },
  created () {
    // this.getRange();
  },
  methods: {
    getRange (mode, local) {
      // { type: 1, local: this.i18n }
      return shareScope({ mode: mode, local: local })
    },
    getCustomerList (params) {
      // {type:1,tab:1}
      return shareScope(params)
    }
  }
}

export default mixin
